/** Versão e data exibidas na sidebar (formato BR). */
export const APP_VERSION = '1.1.0';
export const APP_RELEASE_DATE = '03/06/2025';
export const APP_VERSION_LABEL = `Versão: ${APP_VERSION} - ${APP_RELEASE_DATE}`;
